export default "__VITE_ASSET__B4mad9sE__"